import routerOptions0 from "/root/work/frontends/kakao_gino/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@8.2.0_@parcel+watcher@2.4.1_@types+node@22.15.3_db0@0.3.2_en_ed930961eef1125bfe8bb6e6664142f2/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}